<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="overflow-hidden sm:rounded-lg">
          <div class="text-center">
            <h5>Select a package to edit, or create a new package.</h5>
          </div>

          <div class="grid grid-cols-10 break-words gap-2 mt-2">
            <div class="bg-white rounded-md card-style">
              <jet-responsive-nav-link @click="goToCreate">
                <i
                  class="fas fa-plus fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Add Module</div>
              </jet-responsive-nav-link>
            </div>

            <div
              class="bg-white rounded-md card-style"
              v-on:click="showImportPopup"
            >
              <div class="pt-2 hover:cursor-pointer">
                <i
                  class="fas fa-file-import fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Import</div>
              </div>
            </div>

            <div class="bg-white rounded-md card-style" v-for="mod of sortedModule"  :key="mod.id">
              <jet-responsive-nav-link
                :href="route(moduleRoute + '.show', [slug, mod.name])"
              >
                <i
                  class="fas fa-cubes fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />
                <div class="text-center leading-4">{{ mod.label }}</div>
              </jet-responsive-nav-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- system module be here -->

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="overflow-hidden sm:rounded-lg">
          <div v-if="sys_modules.length" class="text-center">
            <h5>System Module</h5>
          </div>

          <div class="grid grid-cols-10 break-words gap-2 mt-2">
            <div
              class="bg-white rounded-md card-style"
              v-for="sysmod of sortedSysModule"
               :key="sysmod.id"
            >
              <jet-responsive-nav-link
                :href="route(moduleRoute + '.show', [slug, sysmod.name])"
              >
                <i
                  class="fas fa-cubes fa-2x fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">{{ sysmod.label }}</div>
              </jet-responsive-nav-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hybrid module be here -->

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="overflow-hidden sm:rounded-lg">
          <div v-if="hybrid_modules.length" class="text-center">
            <h5>Hybrid Module</h5>
          </div>

          <div class="grid grid-cols-10 break-words gap-2 mt-2">
            <div
              class="bg-white rounded-md card-style"
              v-for="hymod of sortedHybrid"
              :key="hymod.id"
            >
              <jet-responsive-nav-link
                :href="route(moduleRoute + '.show', [slug, hymod.name])"
              >
                <i
                  class="fas fa-cubes fa-2x fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">{{ hymod.label }}</div>
              </jet-responsive-nav-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- console module be here -->

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="overflow-hidden sm:rounded-lg">
          <div v-if="console_modules.length" class="text-center">
            <h5>Console Module</h5>
          </div>

          <div class="grid grid-cols-10 break-words gap-2 mt-2">
            <div class="bg-white rounded-md card-style"  v-for="conmod of sortedData" :key="conmod.id">
              <jet-responsive-nav-link
                :href="route(moduleRoute + '.show', [slug, conmod.name])"
              >
                <i
                  class="fas fa-cubes fa-2x fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />
                <!-- <div class="text-center leading-4">{{ conmod.name }}</div> -->

                <div class="text-center leading-4">{{ conmod.label }}</div>
              </jet-responsive-nav-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Import Popup -->
    <DxPopup
      v-model:visible="popupVisible"
      :width="500"
      :height="440"
      :fullscreen="true"
      :show-title="true"
      :resizeEnabled="true"
      title="Import"
      :drag-enabled="true"
      :close-on-outside-click="true"
    >
      <template #content style="height: 329.6px">
        <DxScrollView width="100%" height="100%">
          <div class="popup-property-details">
            <div
              v-for="item in avl_modules"
              class="grid grid-cols-2 border rounded-lg mt-1 p-2 mx-3"
            >
              <span class="text-left text-black">{{ item }}</span>
              <div class="text-right text-black">
                <input
                  type="checkbox"
                  id=""
                  :value="item"
                  v-model="ImportModules"
                />
              </div>
            </div>
          </div>
          <div class="sticky bg-white mt-12 flex justify-between">
            <div></div>
            <div>
              <button
                @click="importModule"
                class="fixed bottom-2 right-2 btn btn-success mt-2 mr-3"
              >
                Import
              </button>
            </div>
          </div>
        </DxScrollView>
      </template>
    </DxPopup>
  </app-layout>
</template>

<style>
.card-style {
  min-height: 80px;
}

.icon-center {
  text-align: center;
  width: 100%;
}
.dx-popup-content {
  /* -webkit-user-drag: none; */
  padding: 10px 10px 10px 10px;
  /* height: 329.6px; */
}
</style>

<script>
import DxSelectBox from "devextreme-vue/select-box";
import DxList from "devextreme-vue/list";
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxPopup from "devextreme-vue/popup";
import DxButton from "devextreme-vue/button";
import { DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import { DxToast } from "devextreme-vue/toast";
import { DxScrollView } from "devextreme-vue/scroll-view";

import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import Button from "../../Jetstream/Button.vue";
let collapsed = false;

export default {
  props: {
    modules: Array,
    moduleRoute: String,
    slug: String,
    sys_modules: Array,
    avl_modules: {
      type: Object,
      default: () => ({}),
    },
    hybrid_modules: Array,
    console_modules: Array,
    avl_modules: Array,
   
  },
  components: {
    DxList,
    DxSelectBox,
    AppLayout,
    PageTitle,
    JetResponsiveNavLink,
    DxPopup,
    DxButton,
    DxPosition,
    DxToolbarItem,
    Button,
    DxToast,
    DxScrollView,
  },

  data() {
    return {
      title: "Module Builder",
      popupVisible: false,
      ImportModules: [],
      isVisible: false,
      message: "",
      type: "success",
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {
      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
    },
    goToShow() {
      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/show");
    },
    showImportPopup() {
      this.popupVisible = true;
    },
    importModule() {
      this.$inertia.post(
        route(this.moduleRoute + ".import", {
          list: this.ImportModules,
          route_slug: this.slug,
        }),
        {
          onSuccess: this.showToast("Successfully Export", "success"),
        }
      );
      this.popupVisible = false;
      this.ImportModules = [];
    },
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },
  },
  mounted() {
    //console.log("IMPORT", this.ImportModules);
    //console.log("CONSOLE", this.console_modules);
  },
  computed: {
     sortedData() {
      return _.orderBy(this.console_modules, "label");
     
    },
    sortedHybrid(){
      //hybrid_modules
      return _.orderBy(this.hybrid_modules, "label");
    },
    sortedSysModule(){
      //sys_modules
      return _.orderBy(this.sys_modules, "label");

    },
    sortedModule(){
      //modules
      return _.orderBy(this.modules, "label");
    }

  },
};
</script>
